// extracted by mini-css-extract-plugin
module.exports = {"sezzle_header":"sezzle-card_sezzle_header__7HJ3T","text_2_container":"sezzle-card_text_2_container__jqLQv"};